import { ReactElement } from 'react';
import { BaseRepository, IBaseModel, IListFetchParams } from '../../../common';
import { generateGridForm } from '../../../utils';
import React from 'react';

interface Props<T extends IBaseModel, Q extends IListFetchParams> {
  repository: BaseRepository<T, Q>;
}

const CrudBody = <T extends IBaseModel, Q extends IListFetchParams>({
  repository,
}: Props<T, Q>): ReactElement => {
  return (
    <div
      style={{ scrollbarGutter: 'stable both-edges' }}
      className="flex flex-col size-full px-4 max-h-max overflow-y-scroll transform-none overflow-x-hidden sm:max-h-max sm:max-w-full"
    >
      {generateGridForm<T, Q>(repository.formFieldsOptions)}
    </div>
  );
};

export default CrudBody;
